/* BEVANUP_MOBILE_COLLECTION_JALA_V2: reuse the existing desktop facet engine on mobile. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const install = () => {
    if (!mobile.matches) return;
    const main = document.querySelector('main[data-template="collection"]');
    const facets = main?.querySelector('.facets-block-wrapper--horizontal');
    const trigger = facets?.querySelector('.bevanup-collection-filter-trigger');
    const form = facets?.querySelector('.facets__form');
    const panel = form?.querySelector('.bevanup-advanced-filters');
    if (!facets || !trigger || !form || !panel || panel.querySelector('.bevanup-mobile-pc-filter-close')) return;
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'bevanup-mobile-pc-filter-close';
    close.textContent = 'CLOSE';
    panel.prepend(close);
    const syncTop = () => {
      const header = document.querySelector('.header-section');
      const announcement = document.querySelector('.announcement-bar');
      const top = Math.max(header?.getBoundingClientRect().bottom || 0, announcement?.getBoundingClientRect().bottom || 0, 0);
      form.style.setProperty('--bevanup-collection-filter-top', Math.round(top) + 'px');
      const preview = document.getElementById('PBarNextFrameWrapper');
      form.style.setProperty('--bevanup-collection-filter-bottom', Math.max(0, Math.round(preview?.getBoundingClientRect().height || 0)) + 'px');
    };
    const lock = () => { window.__bevanupCollectionScrollY = window.scrollY; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; };
    const unlock = () => { document.documentElement.style.removeProperty('overflow'); document.body.style.removeProperty('overflow'); window.scrollTo(0, window.__bevanupCollectionScrollY || 0); };
    const closePanel = () => { facets.classList.remove('bevanup-filter-open'); trigger.setAttribute('aria-expanded', 'false'); trigger.textContent = trigger.textContent.replace(/^CLOSE/, 'FILTER'); unlock(); };
    close.addEventListener('click', closePanel);
    trigger.addEventListener('click', () => window.requestAnimationFrame(() => { if (facets.classList.contains('bevanup-filter-open')) { syncTop(); lock(); } else unlock(); }));
    window.addEventListener('resize', () => { if (facets.classList.contains('bevanup-filter-open')) syncTop(); });
    facets.classList.add('bevanup-mobile-pc-filter-ready');
  };
  const start = () => { let attempts = 0; const wait = () => { install(); if (++attempts < 30 && !document.querySelector('.bevanup-mobile-pc-filter-close')) window.setTimeout(wait, 100); }; wait(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
